import React, { useRef } from 'react';
import {
	H2, Button
} from '../base';
import * as StyledFilters from './apartmentListFilters.styles';
import { openContextMenu } from '../../actions/contextMenuActions';
import { clearAllFilters } from '../../actions/filtersActions';
import { APARTMENT_LIST_LOCATION_FILTER, APARTMENT_LIST_PRICE_FILTER } from '../../constants/contextMenus';
import RoomCountFilter from './roomCountFilter';

const ApartmentListFilters = ({
	apartmentCount,
	locationFiltersActive,
	priceFiltersActive,
	dispatch
}) => {
	const locationButton = useRef(null);
	const priceButton = useRef(null);

	const openFilter = (filter, ref) => {
		const rect = ref.current.getBoundingClientRect();
		dispatch(openContextMenu(rect.x, (rect.y + rect.height + 10 + window.scrollY), filter));
	};

	const onClearFilters = () => {
		dispatch(clearAllFilters());
	};

	return (
		<StyledFilters.FiltersWrapper>
			<StyledFilters.TitleCountWrapper>
				<H2>Íbúðir</H2>
				<StyledFilters.Count>
					<span>{apartmentCount}</span>
					<span>íbúðir í boði</span>
				</StyledFilters.Count>
			</StyledFilters.TitleCountWrapper>
			<StyledFilters.Buttons>
				<StyledFilters.LocationPriceWrapper>
					<StyledFilters.ButtonWrapper
						ref={locationButton}>
						<StyledFilters.LocationButton
							tertiary={locationFiltersActive}
							onClick={openFilter.bind(null, APARTMENT_LIST_LOCATION_FILTER, locationButton)}>
							<span>Staðsetning</span>
						</StyledFilters.LocationButton>
					</StyledFilters.ButtonWrapper>
					<StyledFilters.ButtonWrapper
						ref={priceButton}>
						<StyledFilters.PriceButton
							tertiary={priceFiltersActive}
							onClick={openFilter.bind(null, APARTMENT_LIST_PRICE_FILTER, priceButton)}>
							<span>Verð</span>
						</StyledFilters.PriceButton>
					</StyledFilters.ButtonWrapper>
				</StyledFilters.LocationPriceWrapper>
				<StyledFilters.RoomCountWrapper>
					<RoomCountFilter />
				</StyledFilters.RoomCountWrapper>
				<StyledFilters.ClearWrapper>
					<Button onClick={onClearFilters}>Hreinsa val</Button>
				</StyledFilters.ClearWrapper>
			</StyledFilters.Buttons>
		</StyledFilters.FiltersWrapper>
	);
};

export default ApartmentListFilters;
